import { Link } from "react-router-dom";

function Hero() {
  return (
    <section className="w-full mt-14 px-12 h-[42vh] lg:h-[64vh] gap-10 lg:px-36 flex justify-center items-center">
      <div className="flex flex-col gap-14 lg:gap-6">
        <p className="text-4xl lg:text-5xl text-center lg:text-left font-extrabold leading-tight">
          Get queued. Manage queues. Efficient actions.
        </p>
        <div className="flex gap-4 justify-center items-center lg:justify-start">
          <Link to="/agent-domain">
            <button className="bg-[#dc9209] min-w-36 rounded-lg p-2 cursor-pointer">
              <span className="font-extrabold text-gray-200 hover:text-gray-300">
                For Brokers
              </span>
            </button>
          </Link>
          <Link to="/buyer-query">
            <button className="hover:bg-gray-300 hover:text-[#dc9209] bg-gray-200 min-w-36 rounded-lg p-2 cursor-pointer">
              <span className="font-extrabold">For Investors</span>
            </button>
          </Link>
        </div>
      </div>
      <div className="max-w-[30vw] hidden md:hidden lg:block">
        <img
          src="https://res.cloudinary.com/dcpgwly0i/image/upload/v1751383081/hero-splash_c1lxxs.png"
          alt="AttnQ-cuts-through-noise-and-connects-with-serious-high-intent-property-buyers—not-random-leads.-Buyers-enter-their-exact-budget-and-dream-property-specs-and-AttnQ-prioritizes-and-queues-them-for-you-based-on-relevance-and-conversion-potential.-You-get-a-clear-ranked-list-of-prospects-ready-to-be-contacted-without-chasing-cold-inquiries."
        />
      </div>
    </section>
  );
}

export default Hero;
